import {
    IUserState,
    UserFeaturesItem,
    userHasFeature,
} from "../../redux/types/IUserState";
import {
    AGENT_SHOW_AGENT_TAB,
    NOTEBOOK_SHOW_NOTEBOOK_APP,
    PREDICTOR_SHOW_CHEMPREDICTOR,
    PROPERTIES_DISPATCH_ESTIMATION,
    PROPERTIES_DATA_ESTIMATION,
    PROPERTIES_DATA_ESTIMATION_INLINE,
    PROPERTIES_SHOW_AGENT,
    PROPERTIES_SHOW_NMR_PREDICTION,
    REACTIONS_SHOW_REACTION_ANALYZER,
    REACTIONS_SHOW_REACTION_COMPONENT_PREDICTION,
    REACTIONS_SHOW_LIBRARY_FLOATING_BUTTON,
    REACTIONS_USE_SHARED_LIBRARY,
    SDS_SHOW_SDS,
    SDS_USE_REALTIME_BUILD,
    STRUCTURE_DRAW_USE_KETCHER,
} from "./FeatureFlags";

const hasFlagAndFeature = (
    user: IUserState | undefined,
    flag: () => boolean,
    feature: UserFeaturesItem
): boolean => !!user && flag() && userHasFeature(user, feature);

const hasFlagAndFeatures = (
    user: IUserState | undefined,
    flag: () => boolean,
    features: UserFeaturesItem[]
): boolean =>
    !!user &&
    flag() &&
    features.every((feature) => userHasFeature(user, feature));

export const REACTIONS_USE_SHARED_LIBRARY_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        REACTIONS_USE_SHARED_LIBRARY,
        UserFeaturesItem.Library
    );

export const REACTIONS_SHOW_LIBRARY_FLOATING_BUTTON_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        REACTIONS_SHOW_LIBRARY_FLOATING_BUTTON,
        UserFeaturesItem.Library
    );

export const PROPERTIES_SHOW_AGENT_ENABLED = (user?: IUserState): boolean =>
    hasFlagAndFeature(user, PROPERTIES_SHOW_AGENT, UserFeaturesItem.Agent);

export const STRUCTURE_DRAW_USE_KETCHER_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        STRUCTURE_DRAW_USE_KETCHER,
        UserFeaturesItem.StructureDrawingKetcher
    );

export const REACTIONS_SHOW_REACTION_COMPONENT_PREDICTION_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        REACTIONS_SHOW_REACTION_COMPONENT_PREDICTION,
        UserFeaturesItem.ReactionSynthesis
    );

export const PROPERTIES_DATA_ESTIMATION_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        PROPERTIES_DATA_ESTIMATION,
        UserFeaturesItem.ChemicalEstimation
    );

export const PROPERTIES_DATA_ESTIMATION_INLINE_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        PROPERTIES_DATA_ESTIMATION_INLINE,
        UserFeaturesItem.ChemicalEstimation
    );

export const PROPERTIES_DISPATCH_ESTIMATION_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeatures(user, PROPERTIES_DISPATCH_ESTIMATION, [
        UserFeaturesItem.ChemicalEstimation,
        UserFeaturesItem.ChemicalSearchEstimationDispatch,
    ]);

export const PROPERTIES_SHOW_NMR_PREDICTION_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        PROPERTIES_SHOW_NMR_PREDICTION,
        UserFeaturesItem.NMRium
    );

export const REACTIONS_SHOW_REACTION_ANALYZER_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        REACTIONS_SHOW_REACTION_ANALYZER,
        UserFeaturesItem.ReactionAnalysis
    );

export const NOTEBOOK_SHOW_NOTEBOOK_APP_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        NOTEBOOK_SHOW_NOTEBOOK_APP,
        UserFeaturesItem.Notebook
    );

export const PREDICTOR_SHOW_CHEMPREDICTOR_ENABLED = (
    user?: IUserState
): boolean =>
    hasFlagAndFeature(
        user,
        PREDICTOR_SHOW_CHEMPREDICTOR,
        UserFeaturesItem.ChemPredictorPrediction
    );

export const SDS_SHOW_SDS_ENABLED = (user?: IUserState): boolean =>
    hasFlagAndFeature(user, SDS_SHOW_SDS, UserFeaturesItem.SDSViewer);

export const SDS_USE_REALTIME_BUILD_ENABLED = (user?: IUserState): boolean =>
    hasFlagAndFeature(
        user,
        SDS_USE_REALTIME_BUILD,
        UserFeaturesItem.ChemicalEstimation
    );

export const AGENT_SHOW_AGENT_TAB_ENABLED = (user?: IUserState): boolean =>
    hasFlagAndFeature(user, AGENT_SHOW_AGENT_TAB, UserFeaturesItem.Agent);
